import './debug-mode.js';

window.global = window;
window.merkle = async function merkle(docId) {
    const merkles = await window.merkleAll();
    return merkles[docId];
};
